import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    data: { public: true },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/auth/pages/register-page/register-page.component').then(
        (m) => m.RegisterPageComponent
      ),
    data: { public: true },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/pages/forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent
      ),
    data: { public: true },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/pages/reset-password-page/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent
      ),
    data: { public: true },
  },
  {
    path: 'validate-account',
    loadComponent: () =>
      import('./features/auth/pages/validate-account-page/validate-account-page.component').then(
        (m) => m.ValidateAccountPageComponent
      ),
    data: { public: true },
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
    data: { public: true },
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./features/static-pages/pages/static-page/static-page.component').then(
            (m) => m.StaticPageComponent
          ),
        data: { type: 'privacy-policy' },
      },
      {
        path: 'terms-conditions',
        loadComponent: () =>
          import('./features/static-pages/pages/static-page/static-page.component').then(
            (m) => m.StaticPageComponent
          ),
        data: { type: 'terms-conditions' },
      },
      {
        path: 'faq',
        loadChildren: () => import('./features/faqs/faqs.routes').then((m) => m.FAQS_ROUTES),
      },
      {
        path: 'about',
        loadChildren: () => import('./features/about/about.routes').then((m) => m.ABOUT_ROUTES),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./features/contact/contact.routes').then((m) => m.CONTACT_ROUTES),
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'fabrics',
        loadChildren: () =>
          import('./features/fabrics/fabrics.routes').then((m) => m.FABRICS_ROUTES),
      },
      {
        path: 'cart',
        loadChildren: () => import('./features/cart/cart.routes').then((m) => m.CART_ROUTES),
      },
      {
        path: 'favorites',
        loadChildren: () =>
          import('./features/favorites/favorites.routes').then((m) => m.FAVORITES_ROUTES),
      },
      {
        path: 'collections',
        loadChildren: () =>
          import('./features/collections/collections.routes').then((m) => m.COLLECTIONS_ROUTES),
      },
      {
        path: 'quotations',
        loadChildren: () =>
          import('./features/quotations/quotations.routes').then((m) => m.QUOTATIONS_ROUTES),
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/orders/orders.routes').then((m) => m.ORDERS_ROUTES),
      },
      {
        path: 'development-requests',
        loadChildren: () =>
          import('./features/development-requests/development-requests.routes').then(
            (m) => m.DEVELOPMENT_REQUESTS_ROUTES
          ),
      },
      // {
      //   path: 'company-users',
      //   loadChildren: () =>
      //     import('./features/company-users/company-users.routes').then(
      //       (m) => m.COMPANY_USERS_ROUTES,
      //     ),
      // },
      {
        path: 'brands',
        loadChildren: () => import('./features/brands/brands.routes').then((m) => m.BRANDS_ROUTES),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' },
    ],
  },
  { path: '**', redirectTo: 'home' },
];
